import axios from 'axios'

export const state = {
  customers: {},
  terms: {},
  customer: null
}

export const getters = {
  listCustomers (state) {
    return state.customers
  },
  listTerms (state) {
    return state.terms
  },
  detailCustomer (state) {
    return state.customer
  },
}

export const mutations = {
  SET_CUSTOMERS (state, customers) {
    state.customers = customers
  },
  TOGGLE_SHOW_DETAIL (state, id) {
    state.customers.data.forEach((item, index) => {
      if (item.id === id) {
        item._showDetails = !item._showDetails;
        state.customers.data.splice(index, 1)
        state.customers.data.splice(index, 0, item)
      }
    });
  },
  SET_TERMS (state, terms) {
    state.terms = terms
  },
  SET_CUSTOMER (state, customer) {
    state.customer = customer
  },
}

export const actions = {
  searchCustomers({ commit }, params = {}) {
    return axios.get(`/customers/search`, { params })
  },
  getListCustomers({ commit }, params = {}) {
    return axios.get('/customers', { params })
  },
  getCustomers({ commit }, params = {}) {
    return axios.get(`/customers`, { params }).then(({ data }) => {
      return commit('SET_CUSTOMERS', data)
    })
  },
  toggleDataDetails: function({commit}, index) {
    return commit('TOGGLE_SHOW_DETAIL', index)
  },
  exportCustomersCsv({commit}, params = {}) {
    return axios.get('/customers/export', { params, responseType: 'blob' });
  },
  getTerms({ commit }, params = {limit: 500}) {
    return axios.get(`/terms`, { params }).then(({ data }) => {
      return commit('SET_TERMS', data)
    })
  },
  getCustomer({ commit }, id) {
    return axios.get(`/customers/${id}`)
  },
  createCustomerProject({ commit }, id) {
    return axios.post(`/customers/${id}/projects`)
  },
  createCustomer({ commit }, customer) {
    const data = {
      name: customer.name,
      abn: customer.abn,
      acn: customer.acn,
      status: customer.status,
      term_id: customer.term ? customer.term.id : null,
      sale_reps: customer.sale_reps ? parseUpdateSaleRep(customer.sale_reps) : [],
      addresses: customer.addresses ? parseAddresses(customer.addresses) : [],
      contacts: customer.contacts ? parseUpdateContacts(customer.contacts) : []
    }
    return axios.post('/customers', data)
  },
  deleteCustomer({commit}, id) {
    return axios.delete(`/customers/${id}`)
  },
  updateCustomer({commit}, customer) {
    customer.term_id = customer.term.id
    const data = {
      name: customer.name,
      abn: customer.abn,
      acn: customer.acn,
      status: customer.status,
      term_id: customer.term ? customer.term.id : null,
      sale_reps: parseUpdateSaleRep(customer.sale_reps),
      addresses: parseUpdateAddress(customer.addresses),
      contacts: parseUpdateContacts(customer.contacts)
    }
    return axios.put(`/customers/${customer.id}`, data)
  },
  importCustomer({commit}, params = {}) {
    const formData = new FormData()
    formData.append('file', params.file, params.file.name)
    formData.append('type', params.type)
    formData.append('force_save', params.force_save)
    formData.append('download_error', params.download_error)
    const responseType = params.download_error ? 'blob' : 'json'
    return axios.post('/customers/import', formData, {responseType: responseType})
  },
  downloadImportCustomersTemplate({ commit }, params = {} ) {
    return axios.get(`/import/customer/download-template`, {responseType: 'blob'})
  },
}

function parseAddresses(addresses) {
  const arrayAddresses = []
  addresses.forEach((item) => {
    const address = {...item}
    address.types = item.types.map(type => type.name)
    arrayAddresses.push(address)
  })
  return arrayAddresses
}

function parseUpdateSaleRep(saleReps) {
  const arraySales = []
  saleReps.forEach((item) => {
    const saleRep = {...item}
    saleRep.staff_id = saleRep.staff ? saleRep.staff.id : null;
    saleRep.types = item.types ? item.types.map(type => type.name) : []
    arraySales.push(saleRep)
  })
  return arraySales
}

function parseUpdateAddress(addresses) {
  const arrayAddresses = []
  addresses.forEach((item) => {
    const address = {...item}
    address.country_id = address.country_id || (address.country && address.country.id)
    address.types = item.types ? item.types.map(type => type.name) : []
    arrayAddresses.push(address)
  })
  return arrayAddresses
}

function parseUpdateContacts(contacts) {
  const arrayContacts = []
  contacts.forEach((item) => {
    const contacts = {...item}
    if (contacts.role) {
      contacts.role_id = contacts.role.id
    }
    arrayContacts.push(contacts)
  })
  return arrayContacts
}
